import styled from 'styled-components'

import { Typography } from '@/components/ui/typography'

export const ItemNameCell = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['8'],
  justifyContent: 'space-between',
  width: '100%',
}))

export const AvatarNameContainer = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['8'],
  minWidth: 0,
  width: '100%',
}))

// Note: a flex item's default `min-width: auto` keeps it from shrinking below its content's
// width - with `white-space: nowrap` (from `breakLines`) that's the *full* unwrapped text width,
// so without this the item name just pushes past the column instead of truncating.
export const ItemNameText = styled(Typography)({
  minWidth: 0,
})

export const TagsContainer = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.space['4'],
}))

export const PriceContainer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['4'],
}))

export const OriginalPrice = styled.span(() => ({
  textDecoration: 'line-through',
}))
